import React, { useState, useEffect } from 'react';
import { VisitorLandingPage } from './VisitorLandingPage';
import { useHistory } from 'react-router-dom';
import { useAuthentication } from '../../authentiction';
import { useInterval } from 'beautiful-react-hooks';
import { IWelcomePage } from '../../admin/theme/form';
import AjaxErrorBoundary from '../../ajax/errorBoundary';
import { useDataFetcher } from '../../hooks';

const VisitorLandingPageContainer: React.FC = () => {
  const { pin, site, themeId } = useAuthentication();
  const history = useHistory();

  const { busy, errors, data: theme } = useDataFetcher(`api/themes/${themeId}`);

  const [siteTheme, setSiteTheme] = useState<IWelcomePage | null>(null);
  const [delay, setDelay] = useState<number>(5000);

  useEffect(() => {
    if (theme) {
      setSiteTheme(theme.welcomePages[0]);
      setDelay(theme.delayInSeconds * 1000);
    }
  }, [theme]);

  useInterval(() => {
    if (siteTheme) {
      let index = theme.welcomePages.findIndex(
        (page: IWelcomePage) => page.id === siteTheme.id,
      );

      if (index === theme.welcomePages.length - 1) {
        index = 0;
      } else {
        index += 1;
      }

      setSiteTheme(theme.welcomePages[index]);
    }
  }, delay);

  return (
    <AjaxErrorBoundary busy={busy} loadingText="Please wait..." errors={errors}>
      {siteTheme && theme && (
        <VisitorLandingPage
          pin={pin}
          site={site}
          siteTheme={siteTheme}
          signInButtonColor={theme.signInButtonColor}
          signInTextColor={theme.signInTextColor}
          signOutButtonColor={theme.signOutButtonColor}
          signOutTextColor={theme.signOutTextColor}
          logoUrl={theme.logoUrl}
          onSignIn={() => history.push('/visitor/signIn')}
          onSignOut={() => history.push('/visitor/signOut')}
        />
      )}
    </AjaxErrorBoundary>
  );
};

export default VisitorLandingPageContainer;
